export enum BookmarkTypes {
  CASE = "case",
  STATUTE = "statute",
  DEPARTMENT = "department"
};